// /**
//  * Node Modules
//  */
import React from 'react'
import { Helmet } from 'react-helmet'
import { graphql } from 'gatsby'

// /**
//  * Application Modules
//  */
import PageContainer from '../../components/page-container'
import Metadata from '../../components/metadata'
import Header from '../../components/header'
import Footer from '../../components/footer'
import Section from '../../components/section'

import Hero from '../../sections/our-story/hero'
import DownloadBanner from '../../components/download-banner'

import './style.css'

// /**
//  * Page Component
//  */
export default function OurStory({ data }) {
  const {
    referencePageMetadata,
    heroDek,
    heroHed,
    slotAHed,
    slotDHed,
    slotEHed,
    slotFHed,
    slotGHed,
    slotHHed,
    slotADek,
    slotBDek,
    slotBHed,
    slotCDek,
    slotCHed,
    slotDDek,
    slotEDek,
    slotFDek,
    slotGDek,
    slotHDek,
    bookDek,
    bookHed,
  } = data.contentfulSingletonOurStory

  return (
    <PageContainer>
      <Helmet>
        <link rel="canonical" href="https://kinzoo.com/our-story/" />
        <meta property="og:url" content="https://kinzoo.com/our-story/" />
      </Helmet>
      <Metadata {...referencePageMetadata} />
      <Header
        styles={{
          '--logo-color': 'var(--purple)',
          '--color': 'var(--light-purple)',
          '--active-color': 'var(--coral)',
          '--background-color': '#f7f7f7',
        }}
      />
      <Hero hed={heroHed} dek={heroDek.heroDek} />
      <Section className="page-story" id="story">
        <div className="page-story__grid-top grid">
          <div className="column-start-1 column-end-6 column-start-1--t column-end-6--t  flex flex-center">
            <img
              className="page-story__img page-story__img-orb"
              alt="Illustration of an overwhelmed woman"
              src="/our-story/our-story-laptop-lady.png"
            />
          </div>
          <div className="column-start-1 column-end-6 column-start-7--t column-end-12--t">
            <h2 className="page-story__hed page-story__hed-orb">{slotAHed}</h2>
            <p className="page-story__dek">{slotADek.slotADek}</p>
          </div>

          <div className="column-start-1 column-end-6 column-start-7--t column-end-12--t  flex flex-center">
            <img
              className="page-story__img  page-story__img-orb"
              alt="Illustration of a curious man"
              src="/our-story/our-story-devices-man.png"
            />
          </div>
          <div className="column-start-1 column-end-6 column-start-1--t column-end-6--t">
            <h2 className="page-story__hed page-story__hed-orb">{slotBHed}</h2>
            <p className="page-story__dek">{slotBDek.slotBDek}</p>
          </div>
        </div>

        <div className="page-story__grid-bottom grid">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width="1280"
            height="86"
            viewBox="0 0 1280 86"
            className="page-story__mid-curve"
          >
            <defs>
              <path id="a" d="M0 0H580V345H0z"></path>
            </defs>
            <g fill="none" fillRule="evenodd">
              <g transform="translate(0 -1406) translate(-524 566) translate(0 10)">
                <path fill="#F7F7F7" d="M526 0H1806V3031H526z"></path>
                <path
                  fill="#FFF"
                  d="M1167.5 0c232.235 0 449.778 26.824 636.52 73.603L1804 86H524l-.012-10.633C712.283 27.499 932.36 0 1167.5 0z"
                  transform="translate(0 830)"
                ></path>
              </g>
              <mask
                fill="#fff"
                transform="translate(0 -1406) translate(-524 566) translate(574 875)"
              >
                <use xlinkHref="#a"></use>
              </mask>
            </g>
          </svg>

          <div className="column-start-1 column-end-6 column-start-1--t column-end-6--t  flex flex-center">
            <img
              className="page-story__img"
              alt="Illustration two kids from the 90s infrom of a computer"
              src="/our-story/90s-computer-party.png"
            />
          </div>
          <div className="column-start-1 column-end-6 column-start-7--t column-end-12--t">
            <h2 className="page-story__hed">{slotCHed}</h2>
            <p className="page-story__dek">{slotCDek.slotCDek}</p>
          </div>

          <div className="column-start-1 column-end-6 column-start-7--t column-end-12--t  flex flex-center">
            <img
              className="page-story__img"
              alt="Illustration of a kid playing a computer game"
              src="/our-story/90s-gaming.png"
            />
          </div>
          <div className="column-start-1 column-end-6 column-start-1--t column-end-6--t">
            <h2 className="page-story__hed">{slotDHed}</h2>
            <p className="page-story__dek">{slotDDek.slotDDek}</p>
          </div>


          <div className="column-start-1 column-end-6 column-start-1--t column-end-6--t flex flex-center">
            <img
              className="page-story__img"
              alt="Illustration of a kid using social media"
              src="/our-story/10s-insta-piggyback.png"
            />
          </div>
          <div className="column-start-1 column-end-6 column-start-7--t column-end-12--t ">
            <h2 className="page-story__hed">{slotFHed}</h2>
            <p className="page-story__dek">{slotFDek.slotFDek}</p>
          </div>

          <div className="column-start-1 column-end-6 column-start-7--t column-end-12--t flex flex-center">
            <img
              className="page-story__img"
              alt="Illustration of kids using phones and tablets"
              src="/our-story/10s-couch-tablets.png"
            />
          </div>
          <div className="column-start-1 column-end-6 column-start-1--t column-end-6--t  ">
            <h2 className="page-story__hed">{slotGHed}</h2>
            <p className="page-story__dek">{slotGDek.slotGDek}</p>
          </div>

          <div className="column-start-1 column-end-6 column-start-1--t column-end-6--t flex flex-center">
            <img
              className="page-story__img"
              alt="Illustration a family connected by the internet"
              src="/our-story/10s-connected-distance.png"
            />
          </div>
          <div className="column-start-1 column-end-6 column-start-7--t column-end-12--t">
            <h2 className="page-story__hed">{slotHHed}</h2>
            <p className="page-story__dek">{slotHDek.slotHDek}</p>
          </div>

          <div className="column-start-1 column-end-6 column-start-7--t column-end-12--t flex flex-center">
            <a
              href="http://www.kidsafeseal.com/certifiedproducts/kinzoo_app.html"
              rel="noopener"
              target="_blank"
            >
              <img
                className="page-story__img"
                alt="KidSafe Coppa Certified Badge"
                src="/our-story/kidsafe-buffered.png"
              />
            </a>
          </div>
          <div className="column-start-1 column-end-6 column-start-1--t column-end-6--t ">
            <h2 className="page-story__hed">{slotEHed}</h2>
            <p className="page-story__dek">{slotEDek.slotEDek}</p>
          </div>



        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1280"
          height="100"
          viewBox="0 0 1280 100"
          className="page-story__book-curve"
        >
          <g fill="none" fillRule="evenodd">
            <g transform="translate(0 -3899) translate(0 3854)"></g>
            <path
              fill="#FFF"
              d="M1895 2493l.017 18.247C1715.044 2563.048 1502.148 2593 1274 2593c-244.419 0-471.332-34.377-659.013-93.165L615 2493h1280z"
              transform="translate(0 -3899) translate(-615 566) translate(0 10) translate(0 830)"
            ></path>
          </g>
        </svg>
      </Section>
      <Section className="book-details" id="story-book">
        <div className="book-details__grid grid">
          <div className="column-start-1 column-end-6 column-start-1--t column-end-4--t column-end-5--d  flex flex-center">
            <a target="_blank" href="https://www.amazon.com/Screen-Captured-Helping-Families-Manipulation-ebook/dp/B07X59PFQ6/ref=sr_1_2?keywords=sean+herman&qid=1568406148&sr=8-2">
              <img
                className="page-story__img"
                alt="Image of the book Screen Captured"
                src="/our-story/book-social-proof.png"
              />
            </a>
          </div>
          <div className="column-start-1 column-end-6 column-start-5--t column-start-7--d column-end-12--t">
            <h2 className="page-story__hed">{bookHed}</h2>
            <p className="page-story__dek">{bookDek.bookDek}</p>
            <div className="book-details__link-group flex flex-center">
              <a
                className="button button--h45-t button--yellow"
                target="_blank"
                href="https://www.amazon.com/Screen-Captured-Helping-Families-Manipulation-ebook/dp/B07X59PFQ6/ref=sr_1_2?keywords=sean+herman&qid=1568406148&sr=8-2"
              >
                Get the Book
              </a>
            </div>
          </div>
        </div>
      </Section>
      <DownloadBanner />
      <Footer />
    </PageContainer>
  )
}

export const pageQuery = graphql`
  query OurStoryQuery {
    contentfulSingletonOurStory(contentful_id: { eq: "2yNSiOVsIi6Jur581vosnt" }) {
      referencePageMetadata {
        pageTitle
        ogTitle
        twitterTitle
        description
        ogDescription
        twitterDescription
        ogImage {
          file {
            url
          }
        }
        twitterImage {
          file {
            url
          }
        }
      }

      id
      heroDek {
        heroDek
      }
      heroHed
      slotAHed
      slotDHed
      slotEHed
      slotFHed
      slotGHed
      slotHHed
      slotADek {
        slotADek
      }
      slotBDek {
        slotBDek
      }
      slotBHed
      slotCDek {
        slotCDek
      }
      slotCHed
      slotDDek {
        slotDDek
      }

      slotEDek {
        slotEDek
      }
      slotFDek {
        slotFDek
      }
      slotGDek {
        slotGDek
      }
      slotHDek {
        slotHDek
      }
      bookDek {
        bookDek
      }
      bookHed
    }
  }
`
